import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateEmail,
	validateNumber,
	validatePassword,
	validateText,
	validateUsername,
} from '../../../util/validation/commonValidation';
import type { UpsertAccountDto } from '../types/AccountDto';

const defaultUpsertAccount: UpsertAccountDto = {
	id: '',
	username: '',
	email: '',
	firstName: '',
	lastName: '',
	password: '',
	checkPassword: '',
	roleId: '',
	branchIds: [],
	isEdit: false,
};

export function useUpsertAccountForm(
	upsertAccount: UpsertAccountDto = defaultUpsertAccount,
) {
	const [inputs, setInputs] = useState<UpsertAccountDto>(upsertAccount);

	const form = useForm<UpsertAccountDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			username: (value) => validateUsername(value),
			email: (value) => validateEmail(value, false),
			firstName: (value) => validateText(value, false, 'First name', 40),
			lastName: (value) => validateText(value, false, 'Last name', 40),
			password: (value, values) => validatePassword(value, values.isEdit),
			checkPassword: (value, values) => {
				// biome-ignore lint/suspicious/noDoubleEquals: <explanation>
				if (!values.isEdit && value != values.password) {
					return 'Passwords do not match';
				}
			},
			branchIds: (value) => {
				if (value.length < 1) {
					return 'Please select at least one branch';
				}
			},
			roleId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Role', false),
		},
		onValuesChange: (v) => {
			setInputs(v);
		},
	});

	return { form, inputs };
}
